// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24xYC","placeholdersHeader":"styles_placeholdersHeader__1iuX_","editorStyle":"styles_editorStyle__18ZCm","placeholdersBox":"styles_placeholdersBox__2t6Do"};